import type {
  GraphLocationDescriptor,
  GraphNavigateOptions,
} from '@ipfabric/utils';

/**
 * Transform GraphLocationDescriptor object to `react-router-dom.navigate` function arguments
 *
 * @example
 * import {useNavigate} from 'react-router-dom';
 * const navigate = useNavigate();
 * // ...
 * navigate(...navigateGraphToLocation(createTopologyGraphLink(...))));
 */
export const navigateGraphToLocation = ({
  to,
  state,
  replace,
}: GraphLocationDescriptor): [to: string, options: GraphNavigateOptions] => [
  to,
  { state, replace },
];
